import { extend, ExtendOptionsInit } from 'umi-request';
import clientAjax from './clientAjax';

const pontCore = require('@/services/pontCore').PontCore;

interface RequestOptions extends ExtendOptionsInit {
  fileName?: string;
  checkResponse?: boolean;
  showError?: boolean | string;
  showSuccess?: boolean | string;
}

export interface ResponseType {
  data?: any;
  message?: string;
  status: number;
}

export enum STATUS {
  FAIL = 0, // 操作失败
  SUCCESS = 1, // 成功
  NOT_LOGIN = 305, // 用户未登录
  NOT_FOUND = 404, // 数据不存在
  NOT_ALLOWED = 405, // 没有权限操作
  STATUS_ERROR = 412, // 状态错误
  PARAM_ERROR = 414, // 参数错误
  DATA_FOUND = 417, // 数据已存在
  UNKNOWN_ERROR = 500, // 未知错误
}

/**
 * 自定义request
 */
const ajax = extend({});

/**
 * 请求响应为blob对象时解析文件并下载
 * @param response
 * @param fileName
 */
// const ajaxDownload = (response: Response, fileName?: string) => {
//   response.blob &&
//     response.blob().then((blob: any) => {
//       download(blob, fileName || '');
//     });

//   return response;
// };

ajax.interceptors.request.use((url, params) => {
  // const token = getHeaderToken();
  const meetingId = window.location.pathname.match(/\/meet\/(\d{6,9})/)?.[1] || '';
  const { body, params: customParams = {}, ...options } = params;
  const { removeHeaderToken, checkResponse = true } = customParams as any;
  let { headers } = options;
  headers = {
    // 9 表示为 web 端
    deviceType: '9',
    ...headers,
  };
  if (meetingId) {
    // @ts-ignore
    headers.meetingId = meetingId;
  }
  // 个别自定义请求body中已带有token，header中包含token会报错
  // if (IS_DEV && token && !removeHeaderToken) {
  //   headers = { [HEADER_TOKEN_KEY]: token, ...headers };
  // }

  if (body) {
    options.data = body;
  }

  return {
    url,
    options: { ...options, headers, checkResponse, interceptors: true, params: customParams },
  };
});

/**
 * 自定义response拦截器
 */
ajax.interceptors.response.use(async (response: Response, options: RequestOptions) => {
  const { fileName, checkResponse, showError = true, showSuccess } = options;
  let { responseType = 'json' } = options;

  // responseType为blob时下载文件
  if (responseType === 'blob') {
    const acceptRanges = response.headers.get('accept-ranges');

    if (acceptRanges === 'bytes') {
      // return ajaxDownload(response, fileName);
    }

    responseType = 'json';
  }

  if (checkResponse && responseType === 'json') {
    const jsonData = (await response.clone()[responseType]()) as ResponseType;
    const { message, status, data } = jsonData;

    if (status === STATUS.SUCCESS) {
      // 请求成功
      if (showSuccess) {
        // Message.success(message || '操作成功');
      }
    } else {
      // 请求失败
      if (status === STATUS.NOT_LOGIN) {
        // authLogin();
      } else if ([STATUS.NOT_FOUND, STATUS.NOT_ALLOWED].includes(status)) {
        // 数据不存在/没有权限操作，进行路由调整处理
        // history.push('/404');
      } else if (showError) {
        // Message.error(message || '操作失败');
      }

      throw jsonData;
    }
  } else {
    // 部分第三方接口返回格式与一般格式不同，另行校验
    const { status } = response;

    if (status !== 200) {
      // Message.error('操作失败');
      throw response;
    }
  }

  return response;
});

pontCore.useFetch((...params: any) => {
  // const headers = { cip: window.returnCitySN?.cip };
  let axiosParams = {};
  if (params[1].body && params[1].body.data) {
    axiosParams = {
      ...params[1],
      ...params[1].body,
      // headers,
    };
  } else {
    axiosParams = {
      ...params[1],
      data: params[1].body,
      // headers,
    };
  }
  if (params[0]?.includes('/api/bs-vmeeting/v3/')) {
    return clientAjax(params[0], axiosParams);
  }
  return ajax(params[0], axiosParams);
});

export default ajax;
